import { WebsocketRequestType } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { getCurrentProfileId } from '@mews-commander/core';
import { getCurrentProfileScopeId } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { createWebsocketSubscriptionActions } from '../../../core/websockets';

export const SUBSCRIPTION_RESERVATIONS = 'SUBSCRIPTION_RESERVATIONS';

const [subscribe, unsubscribe] = createWebsocketSubscriptionActions(
    SUBSCRIPTION_RESERVATIONS,
    WebsocketRequestType.UpdateReservationUpdateSubscription
);

export const subscribeReservationUpdates = (): CommanderThunkAction => (dispatch, getState) => {
    const state = getState();
    const profileIds = [getCurrentProfileId()];
    const scopeIds = [getCurrentProfileScopeId(state)];
    return dispatch(subscribe({ profileIds, scopeIds }));
};

export const unsubscribeReservationUpdates = (): CommanderThunkAction => (dispatch) => dispatch(unsubscribe());
